"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorAttemptsExhausted = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _ContentLayout = require("../ContentLayout");
var styles = _interopRequireWildcard(require("./TwoFactorAttemptsExhausted.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TwoFactorAttemptsExhausted = _ref => {
  let {
    onSupport,
    onCancel
  } = _ref;
  return /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, null, /*#__PURE__*/React.createElement("div", {
    className: styles['buttons']
  }, /*#__PURE__*/React.createElement(_uiKit.Button, {
    "data-name": "SupportBtn",
    theme: "fill_primary",
    fullWidth: true,
    onClick: onSupport
  }, "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C"), /*#__PURE__*/React.createElement(_uiKit.Button, {
    "data-name": "CancelBtn",
    theme: "fill_secondary",
    fullWidth: true,
    onClick: onCancel
  }, "\u041E\u0442\u043C\u0435\u043D\u0430")));
};
exports.TwoFactorAttemptsExhausted = TwoFactorAttemptsExhausted;